import {
  FC,
  createContext,
  PropsWithChildren,
  useContext,
  useMemo
} from 'react'

import usePopup, { PopupReturnType } from 'hooks/usePopup'
import { initialPopup } from '../../../hooks/constants'

type ContextProps = {
  historyGoalsPopup: PopupReturnType
}

const basePopup = (title: string) => ({
  title
})

const SavingGoalsPopupContext = createContext<ContextProps>({
  historyGoalsPopup: initialPopup
})

const SavingGoalsPopupProvider: FC<PropsWithChildren> = ({ children }) => {
  const historyGoalsPopupProps = usePopup(basePopup('History'))

  const context = useMemo(
    () => ({
      historyGoalsPopup: historyGoalsPopupProps
    }),
    [historyGoalsPopupProps]
  )

  return (
    <SavingGoalsPopupContext.Provider value={context}>
      {children}
    </SavingGoalsPopupContext.Provider>
  )
}

export const useSavingGoalsPopup = () => useContext(SavingGoalsPopupContext)

export default SavingGoalsPopupProvider
